module.exports = __webpack_public_path__ + "img/transfer19.438b2685.jpeg";